import { action, makeObservable } from 'mobx';

import { IFormField } from 'stores/interfaces/IFormField';

import { BaseFormStore } from '../BaseFormStore';

export abstract class FormStore<FM extends Record<string, IFormField<any>>> extends BaseFormStore<FM> {
  abstract submit(...args: any[]): any;

  constructor() {
    super();

    makeObservable(this, {
      submit: action.bound,
    });
  }
}
